export default function ActivityTimeline({ activities, onClear, isPaused }) {
  const getEventIcon = (type) => {
    const icons = {
      policy: '📋',
      premium: '💰',
      claim: '⚠️',
      payment: '💳',
      commission: '💵',
      ceding: '📤',
      recovery: '📥',
      rate: '📊',
      warning: '⚠️',
      critical: '🚨',
      reinsurance: '🌐'
    }
    return icons[type] || '•'
  }

  const getEventClass = (type) => {
    const classes = {
      policy: 'border-l-[#4caf50]',
      premium: 'border-l-[#ffd700]',
      claim: 'border-l-[#f44336]',
      payment: 'border-l-[#2196f3]',
      commission: 'border-l-[#ffeb3b]',
      ceding: 'border-l-[#ff9800]',
      recovery: 'border-l-[#e91e63]',
      rate: 'border-l-[#9c27b0]',
      warning: 'border-l-[#ff9800]',
      critical: 'border-l-[#f44336]',
      reinsurance: 'border-l-[#ff6b6b]'
    }
    return classes[type] || 'border-l-[#444]'
  }

  return (
    <div className="fixed right-5 top-5 bottom-5 w-[260px] bg-[#1a1a1a] border-2 border-[#333] rounded-xl shadow-[0_5px_20px_rgba(0,0,0,0.5)] flex flex-col z-[100]">
      <div className="p-4 pb-3 border-b border-[#333] flex justify-between items-center">
        <h3 className="m-0 text-[#667eea] text-lg font-medium">Activity Feed</h3>
        <button
          onClick={onClear}
          className="bg-[#333] border-none text-[#888] px-3 py-1 rounded text-xs cursor-pointer transition-all hover:bg-[#444] hover:text-white"
        >
          Clear
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-2.5 custom-scrollbar">
        {activities.length === 0 ? (
          <div className="text-center py-10 px-5 text-[#666]">
            <p className="my-2.5 text-sm">Activity will appear here as the simulation runs.</p>
            <p className="my-2.5 text-xs text-[#555] italic">
              {isPaused ? 'Resume to continue' : 'Click circles to trigger events'}
            </p>
          </div>
        ) : (
          activities.map((activity, index) => (
            <div
              key={`${activity.time}-${index}`}
              className={`flex gap-3 p-3 mb-2 bg-[#222] border-l-[3px] rounded-md transition-all ${
                getEventClass(activity.type)
              } ${isPaused ? 'cursor-pointer hover:bg-[#333] hover:-translate-x-0.5' : ''}`}
            >
              <div className="text-xl leading-none">{getEventIcon(activity.type)}</div>
              <div className="flex-1">
                <div className="text-[0.7rem] text-[#666] mb-1">{activity.time}</div>
                <div className="text-[0.85rem] text-[#ddd] font-medium mb-1">
                  {activity.description}
                </div>
                {activity.details && (
                  <div className="text-xs text-[#999] leading-[1.4]">{activity.details}</div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  )
}

